import { ReactNode } from "react";

import { toast } from "@upstageai/ui";

import { link } from "../../constants/Link";

export default function ErrorToast({
  title,
  description,
  duration = 3000,
  showSupportLink = false,
}: {
  title?: string;
  description?: ReactNode;
  duration?: number;
  showSupportLink?: boolean;
}) {
  toast({
    title: title,
    description: (
      <>
        <span>{description}</span>
        {showSupportLink && (
          <span>
            Please contact us.{" "}
            <a href={link.SUPPORT} className="text-accent-blue underline">
              support
            </a>
          </span>
        )}
      </>
    ),
    className:
      "text-accent-red-foreground p-ui-medium p-4 rounded-lg bg-accent-red-background",
    duration: duration,
  });
}
